export const LOGOFF_QUERY_KEY = ['logoff'] as const;
